import React, { useEffect, useState } from "react";
import ExportButton from "./Export";
import ExportTemplate from "./ExportTemplate";
import { ResolutionKeys, StateToShow } from "../types";
//import "./waterTypeExport.css";
import { CSVLink } from "react-csv";

interface WaterTypeExportProps {
  polygon_values: { [key: string]: string; }[];
  current_resolution: ResolutionKeys;
  current_dataset: string;
  current_attribute: string;
  current_parameters: StateToShow;
  current_year: number|undefined;
}
const WaterTypeExport = ({
  polygon_values,
  current_resolution,
  current_dataset,
  current_attribute,
  current_parameters,
  current_year,
}: WaterTypeExportProps) => {
  // const [selectedWaterType, setSelectedWaterType] = useState<string>("fsw");
  // const getPolygonValues = () => {
  //   if (selectedWaterType === "fsw") {
  //     return polygon_values[2];
  //   } else if (selectedWaterType === "gsw") {
  //     return polygon_values[1];
  //   } else {
  //     return polygon_values[0];
  //   }
  // }
  const indexMap: { [key: number]: string } = {
    0:"fgw",
    1:"bgw",
    2:"fsw"
  }

  const allKeys = Array.from(
    new Set(polygon_values.flatMap((obj) => Object.keys(obj)))
  ).sort();

  // Create CSV data
  const csvData = allKeys.map((key) => {
    const row: Record<string, string> = { Key: key };
    polygon_values.forEach((obj, index) => {
      row[`Polygon ${index + 1}`] = obj[key] || ""; 
    });
    return row;
  });

  // Define CSV headers
  const headers = [
    { label: "Key", key: "Key" },
    ...polygon_values.map((_, index) => ({
      label: `${current_attribute}_${indexMap[index]}`,
      key: `Polygon ${index + 1}`,
    })),
  ];

  return (
    <div className="export">
      <CSVLink data={csvData} headers={headers} filename={"polygon_values.csv"}>
        <button className="btn btn-primary">Export to CSV</button>
      </CSVLink>
    </div>
  );};


export default WaterTypeExport;
